import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { CURRENCY_FORMATTER } from 'common/constants';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { setSkuSelected } from 'v3/data/store/product/actions';
import { MoreVertIconStyled } from 'v3/pages/Products/List/styles';
import { changeProductLmi } from 'v3/pages/Products/List/useCases/change-product-lmi';
import * as api from 'v3/services/api';
import { ISku } from 'v3/services/interfaces/response';
import { MenuProductList } from 'v3/shared/components/Inputs/MenuProductList';
import { ChangeValueModal } from 'v3/shared/components/Modal/ChangePriceModal';
import { FeatureFlagEnum } from 'v3/shared/enums/feature-flag.enum';
import {
  AlignClientInfo,
  AlignValues,
  BodyLine,
  DeviceImg,
  HeaderLine,
  HeaderLineMaxPercentage,
  MainContainer,
  SubtitleLine,
  TableCellInRow,
} from '../styles';

interface ProductMobileTableProps {
  items: ISku[];
}

export const ProductMobileTable: React.FC<ProductMobileTableProps> = ({ items }) => {
  const { skuSelected } = useStoreSelector((store) => store.products);
  const [changeLmiModalOpen, setChangeLmiModalOpen] = useState(false);
  const [sellerFeatureEnabled, setSellerFeatureEnabled] = useState<boolean>(false);

  const fetchSellerFeatureFlag = useCallback(async () => {
    const response = await api.getFlagStatus(FeatureFlagEnum.IKCLOUD_3074_IMPLEMENT_MAXIMUM_VALUES);
    if (response.data.enabled) {
      setSellerFeatureEnabled(true);
    }
  }, []);

  useEffect(() => {
    fetchSellerFeatureFlag();
  }, []);

  const handleOpenEditProductLmiModal = (sku: ISku) => {
    setSkuSelected(sku);
    setChangeLmiModalOpen(true);
  };

  // const handleOpenInsuranceModal = (sku: ISku) => {
  //   setSkuSelected(sku);
  //   setInsuranceModalOpen(true);
  // };

  const changeLmiHandler = async (lmi: number) => {
    await changeProductLmi({ ...skuSelected, lmi: Number(lmi) / CURRENCY_FORMATTER });
  };

  return (
    <Fragment>
      {items.map((item) => (
        <MainContainer key={item.id}>
          <AlignValues>
            <HeaderLine>Modelo</HeaderLine>
            <AlignClientInfo>
              <DeviceImg src={item.image.marketingUrl} alt={item.id} />
              <BodyLine>{item.product.name}</BodyLine>
              <SubtitleLine>{`${item.storage}GB`}</SubtitleLine>
            </AlignClientInfo>
          </AlignValues>

          <AlignValues>
            <HeaderLine>LMI</HeaderLine>
            <AlignClientInfo>
              <TableCellInRow>
                <BodyLine>{`R$ ${item.lmi.toFixed(2)}`}</BodyLine>
                <EditOutlinedIcon onClick={() => handleOpenEditProductLmiModal(item)} />
              </TableCellInRow>
            </AlignClientInfo>
          </AlignValues>

          {sellerFeatureEnabled && (
            <>
              <AlignValues>
                <HeaderLine>Preço base</HeaderLine>
                <AlignClientInfo>
                  <BodyLine>{`R$ ${item.basePrice.toFixed(2)}`}</BodyLine>
                  <SubtitleLine> {'Valor máximo do'}</SubtitleLine>
                  <SubtitleLine> {`aparelho: R$ ${item.maxPrice.toFixed(2)}`}</SubtitleLine>
                </AlignClientInfo>
              </AlignValues>
              <AlignValues>
                <HeaderLineMaxPercentage>Mais opções</HeaderLineMaxPercentage>
                <AlignClientInfo>
                  <TableCellInRow>
                    <MoreVertIconStyled>
                      <MenuProductList sku={item} />
                    </MoreVertIconStyled>
                  </TableCellInRow>
                </AlignClientInfo>
              </AlignValues>
            </>
          )}

          {/* <AlignValues>
            <HeaderLine>Seguros</HeaderLine>
            <AlignClientInfo>
              <TableCellInRow>
                <BodyLine>2/4 habilitados</BodyLine>
                <EditOutlinedIcon onClick={() => handleOpenInsuranceModal(item)} />
              </TableCellInRow>
            </AlignClientInfo>
          </AlignValues> */}

          <ChangeValueModal
            modal={{
              initialPrice: skuSelected.lmi,
              active: changeLmiModalOpen,
              title: 'Editar preço do LMI',
              activeButton: true,
              cancelButton: 'Cancelar',
              saveButton: 'Salvar',
            }}
            onClose={() => setChangeLmiModalOpen(false)}
            onConfirm={changeLmiHandler}
          />

          {/* <InsuranceModal
            modal={{
              active: insuranceModalOpen,
              title: 'Habilitar/Desabilitar seguros',
              activeButton: true,
              cancelButton: 'Cancelar',
              saveButton: 'Salvar',
            }}
            onClose={() => setInsuranceModalOpen(false)}
            onConfirm={handleSaveInsurance}
          /> */}
        </MainContainer>
      ))}
    </Fragment>
  );
};
